import * as actionTypes from './actiontypes'
import states from './states'

import { MODULE_DATA } from '../../config/constants'

const apilogs_details = (state = states.apilogs_details, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_APILOGS_STATE:
      return {
        ...state,
        ...action.payload
      }

    case actionTypes.UPDATE_APILOGS_SELECTED_FILTERS:
      return {
        ...state,
        selected_filters: {
          ...state.selected_filters,
          ...action.payload
        }
      }

    case actionTypes.APILOGS_LOADED: {
      let index = -1
      if (state.selected_api.id)
        index = action.payload.findIndex(item => item._id === state.selected_api.id)
      return {
        ...state,
        apilogs: [...action.payload],
        load_more: action.payload.length === MODULE_DATA.API_LOGS.LOAD_MORE_API_LOGS_COUNT,
        selected_api: index === -1 ? { ...states.apilogs_details.selected_api } : { ...state.selected_api },
      }
    }

    case actionTypes.MORE_APILOGS_RECEIVED: {
      return {
        ...state,
        apilogs: [...state.apilogs, ...action.payload],
        load_more: action.payload.length === MODULE_DATA.API_LOGS.LOAD_MORE_API_LOGS_COUNT
      }
    }

    default:
      return state
  }
}

export default apilogs_details



// WEBPACK FOOTER //
// ./src/data/redux/apilogs_details/reducers.js